function loadModules() {
  const files = require.context('', true, /[A-Za-z0-9-_\s]\/index\.js$/i);
  const modules = {};
  files.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\/index\.js/i);
    if (matched && matched.length > 1) {
      const dependency = matched[1];
      modules[dependency] = files(key).default;
    }
  });

  return modules;
}

function loadRoutes() {
  const files = require.context('', true, /[A-Za-z0-9-_\s]\/routes\.js$/i);
  let routes = [];
  files.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\/routes\.js/i);
    if (matched && matched.length > 1) {
      routes = routes.concat(files(key).default);
    }
  });

  return routes;
}

export const modules = {
  ...loadModules()
};

export const routes = loadRoutes();
